import { AfterViewInit, Component, Input, TemplateRef } from '@angular/core';
import { ICards, IDataSource } from 'bi-interfaces';
import { Subscription } from 'rxjs';
import { ChangeDetectorRef, EventEmitter, Inject, LOCALE_ID, OnDestroy, OnInit, Output, ViewChild, ViewRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IChangeset } from 'bi-interfaces/lib/interfaces/IChangeset';
import { BehaviorSubject, Observable, merge, pipe ,Subject} from 'rxjs';
import { IColumns } from 'bi-interfaces/lib/interfaces/IColumns.interface';
import { DataTypes as DataType } from 'bi-interfaces';
import { MessageService } from '@progress/kendo-angular-l10n';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';
import { BIModulesService } from '../../bi-modules.service';
import { GetValuePipe } from '../../pipes/get-value.pipe';
import { ErrorDetailsService } from '../../services/error-details.service';
import { LoggerService } from '../../services/logger.service';
import { switchMap } from 'rxjs/operators';
import { ExtendedMap } from 'bi-interfaces';
import { BeforeAction } from '../BI-Grid/bi-grid.component';
import { toODataString } from '@progress/kendo-data-query';


export enum LoadingMode {
	Lazy = "Lazy",
	Eager = "Eager"
  }

  enum StatusAction {
	ADD = "Add",
	UPDATE = "Update",
	NOP = "NOP",
	Delete = "Delete"
  }

  class JSONPatchReq {
	op!: string;
	path!: string;
	value: any
  }
@Component({
	selector: 'bi-cards',
	templateUrl: './bi-cards.component.html',
	styleUrls: ['./bi-cards.component.scss']
})
export class BiCardsComponent implements ICards, AfterViewInit {
	@Input() CardTemplate: any;
	@Input() HeaderTemplate!: TemplateRef<any>;
	@Input() FooterTemplate!: TemplateRef<any>;
	@Input() DataService!: IDataSource;
	@Input() CardsListVH: number = 100;
	@Input() LoadingMode: LoadingMode = LoadingMode.Lazy;
  @Input() CardEditTemplate: any;
  @Input() Columns!: IColumns[];
  @Input() public changeSet!: IChangeset;
  @Input() HasExport!: boolean;
  @Input() ExportFileName!: string;
  @Input() EnableCRUD!: boolean;
  @Input() IsChild!: boolean;
  @Input() DomID!: string;
  @Output() CellClose = new EventEmitter<any>();
  @Output() OnCardChange = new EventEmitter<any>();
  @Output() OnAddRow = new EventEmitter<any>();
  @Output() OnCloseRow = new EventEmitter<any>();
  @Output() AfterSave = new EventEmitter<any>();
  @Output() AfterCancel = new EventEmitter<any>();
  @Output() AfterLoad = new EventEmitter<any>();
  @Output() AfterAddRow = new EventEmitter<any>();
  @Output() AfterAdd = new EventEmitter<any>();
  @Output() OnSort = new EventEmitter<any>();

  IneditMode:Map<string,boolean>=new Map();
	private _filters!: string;
	private _sorters!: string;
	private IsInScroll: number = 0;
	private CardData: any;
	private CardDataSubscription!: Subscription;
	StopSaveSubscription!: Subscription;
  StopDeleteSubscription!: Subscription;
  DeleteSubscription!: Subscription;
  AddSubscription!: Subscription;
  GridDataSubscription!: Subscription;
	view: any[] = [];
	data: any[] = [];
	form: any = {};
	RowIdentifier: string = 'R_WID';
  ChangeSet_Status: string = 'ChangeSet_Status';
  CurrentSelectRow!: FormGroup;
  rowCol!: IColumns;
  Status!: IColumns;
  formGroups = new ExtendedMap();
  currentEditingCard: any
  editedFormGrop: any;
  DefaultValue: any = {};
  public statusAction: StatusAction = StatusAction.NOP;
  AllowSave!: Subject<boolean>;
  AllowDelete!: Subject<boolean>;
  AllowAdd!: Subject<boolean>;
  ExportToExcel(): void {
    throw new Error('Method not implemented.');
  }
  constructor(
    public formBuilder: FormBuilder,
    public biService: BIModulesService,
    public messages: MessageService,
    public translateService: TranslateService,
    private cd: ChangeDetectorRef,
    public getValuePipe: GetValuePipe,
    public errorDetailsService: ErrorDetailsService,
    public loggerService: LoggerService,

  ) {
  }
  public SetValue(ColumnName: string, Value: any, MarkAsDirty: boolean = true): void {
    this.CurrentSelectRow.controls[ColumnName].patchValue(Value);
    if (MarkAsDirty) {
      this.CurrentSelectRow.markAsDirty();
      this.CurrentSelectRow.get(ColumnName)?.markAsDirty();
    }
  }
  public GetValueOf(Name: string): any {
    return this.CurrentSelectRow.get(Name)?.getRawValue();
  }
  ngOnInit(): void {
	if(this.EnableCRUD==true){
		this.DataService.Columns.forEach((res: any) => this.form[res.Name] = [null]);
    	this.form[this.RowIdentifier] = [''];
    	this.form[this.ChangeSet_Status] = [''];
		this.AllowSave = new Subject<boolean>();
		this.AllowSave.next(true);
		this.AllowDelete = new Subject<boolean>();
		this.AllowDelete.next(true);
		 this.handleFormGroup();
		 this.PushChangesArr();
	}
	setTimeout(() => {
      this.getCardData();
    });


  }
  PushChangesArr() {
    this.changeSet.changesetArr.push({ Grid: this })
  }
  ngAfterViewInit(): void {

  }

  getCardData() {
    this.CardData = this.DataService;
    if (this.CardDataSubscription)
      this.CardDataSubscription.unsubscribe()
    this.CardDataSubscription =
    this.CardData.subscribe((res: any) => {
      this.data = res['data'];
      if (this.data && this.EnableCRUD==true) {
        this.InitReactiveFormData();
      }
      if (this.IsInScroll) {
        if (this.data?.length) this.view = [...this.view, ...this.data];
        this.IsInScroll--;
      }
      else {
        this.view = this.data;
      }
	  this.AfterLoad.emit(null);
      if(this.data?.length==0 &&  this.view?.length==0 )
	  {
		this.view=[{Angular_No_Rec:true}]
	  }
    });
  }
  loadMore() {
    if (this.LoadingMode == LoadingMode.Lazy) {
      this.IsInScroll++;
      this.DataService.state.skip += 10;
      this.read();
    }
  }

	set filters(filter: string) {
		this._filters = filter;
		this.DataService.state.skip = 0;
		this.read();
	}

	set sorter(sorter: string) {
		this.OnSort.emit();
		this._sorters = sorter;
		this.DataService.state.skip = 0;
		this.read();
	}

	public read() {
		let filtersToRead = '';
		if (this.LoadingMode == LoadingMode.Lazy) {
		  filtersToRead = (this._filters ?? '');
		  if (this.DataService.state.sort)
			filtersToRead += '&' + toODataString({ "sort": this.DataService.state.sort });
		  filtersToRead += `&${this._sorters ?? ''}`;
		  filtersToRead += `&$skip=${this.DataService.state.skip}&$top=${this.DataService.state.take}&$count=true`;
		}
		else{
			if (this.DataService.state.sort)
				filtersToRead = toODataString({ "sort": this.DataService.state.sort });
		  }
		this.DataService.read(filtersToRead);
	}
	  public GetNewRowID(): string {
		const formattedDateTime: string = `${Math.random()}`;
		return formattedDateTime;
	  }


	  InitReactiveFormData() {
		if (!this.IsInScroll) {
		  this.formGroups = new ExtendedMap();
		  this.IneditMode=new Map<string,boolean>();
		}
		this.data.forEach((response: any, index: any) => {
		  let rowID=this.GetNewRowID();
		  response[this.RowIdentifier] =rowID
		  this.IneditMode.set(response[this.RowIdentifier],false);
		  let formGroup = this.formBuilder.group(this.form);
		  formGroup.patchValue({ ...response });
		  Object.keys(formGroup.controls).forEach((name: any) => {
			if (name.includes(".")) formGroup.controls[name].patchValue(this.getValuePipe.get(response, name));
		  })
			// this.setDefaultDate(formGroup);

		  this.formGroups.set(rowID,formGroup);
		});
	  }
	  setDefaultDate(form: any) {
		const dateColumns = this.Columns.filter((res) => res.DataType === DataType.Date);
		dateColumns.map((res) => {
		  if (form.controls?.[res.Name]?.value !== null) {
			const dateValue = form.controls?.[res.Name]?.value as string;
			form.controls?.[res.Name]?.patchValue(new Date(dateValue))
		  }
		  else {
			//  form.controls?.[res.Name].patchValue(new Date(''));
		  }
		})
	  }
	  handleFormGroup() {
		this.rowCol = {
		  Name: this.RowIdentifier, IsVisible: false, DefaultValue: null, DisplayName: this.RowIdentifier, DataType: DataType.Text, IsEditable: false,
		  IsFilterable: false, controlType: "text", viewCellStyle: "", DomID: "", Validators: null
		}
		this.Status = {
		  Name: this.ChangeSet_Status, IsVisible: false, DefaultValue: null, DisplayName: this.ChangeSet_Status, DataType: DataType.Text, IsEditable: false,
		  IsFilterable: false, controlType: "text", viewCellStyle: "", DomID: "", Validators: null
		}
		this.Columns.push(this.rowCol);
		this.Columns.push(this.Status);
		this.Columns.forEach(res => {
		  if (this.form.hasOwnProperty(res.Name)) this.form[res.Name] = [{ value: res.DefaultValue, disabled: !res.IsEditable }, res.Validators];
		  this.DefaultValue[res.Name] = res.DefaultValue;
		});
	  }

	  public GetRowValue(): any {
		return this.CurrentSelectRow.getRawValue();
	  }
	  public async DeleteRow() {
		if (!(this.CurrentSelectRow?.status === 'VALID' || this.CurrentSelectRow?.status === 'DISABLED')) {
		  return
		}
		if (this.GetRowValue()[this.DataService.Key] !== null &&this.GetRowValue()[this.DataService.Key] !== undefined) {
		  let ret = await this.BeforeActionDelete();
		  this.StopDeleteSubscription?.unsubscribe();
		  this.StopDeleteSubscription = this.AllowDelete?.subscribe((res: any) => {
			if (res) {
			  if (this.DeleteSubscription)
				this.DeleteSubscription.unsubscribe();
			  let Delete$;
			  Delete$=this.DataService.delete(this.HandleParamsApiRequest(this.GetRowValue()));
			  this.DeleteSubscription = Delete$.subscribe((res: any) => {
				this.read();
				this.alertShow(`(${this.translateService.instant(this.DataService.Key)}: ${this.GetRowValue()[this.DataService.Key]}) ${this.translateService.instant('RecordedDeletedSuccessfully')}`, 2);
			  });
			}
		  })
		  if (ret === BeforeAction.NoDeleteImp) {
			this.AllowDelete?.next(true);
		  }
		} else {
		  this.alertShow(this.translateService.instant("selectDelete"), 1);
		}

	  };




	  AddRow() {

		  if (!this.CheckPendingChange() || this.IsChild==true) {
		   if(this.CloseAll()){
			  this.statusAction = StatusAction.ADD;
			  let formGroup = this.formBuilder.group(this.form);
			  let RowID = this.GetNewRowID();
			  formGroup.patchValue({ ...this.DefaultValue, [this.ChangeSet_Status]: StatusAction.ADD, [this.RowIdentifier]: RowID });
			  this.setDefaultDate(formGroup);
			  this.formGroups.set(RowID,formGroup);
			  this.IneditMode.set(RowID,true);
			  this.CurrentSelectRow = this.formGroups.get(RowID);
			  this.OnAddRow.emit(null);
			  this.view.unshift(this.formGroups.get(RowID).getRawValue());
			  this.view = [...this.view];
			  this.AfterAddRow.emit(null);
		   }
		  }
		  else {
			this.alertShow(this.translateService.instant('Savependingchanges'), 1);
		  }
	  }


	  ValidateDirtyBeforeSave(formgroups: ExtendedMap) {
		for (let f of formgroups.values()) {
		  if (f.get(this.ChangeSet_Status)?.value == null && f.dirty) {
			f.patchValue({ [this.ChangeSet_Status]: StatusAction.UPDATE });
		  }
	  }
	  }

	  CheckPendingChange(): boolean {
		for (var i = 0; i < this.changeSet?.changesetArr.length; i++) {
		  if (this.IsDirty(this.changeSet.changesetArr[i].Grid.formGroups as ExtendedMap)) {
			return true;
		  }
		}
	  return false;
	  }
	  IsDirty(formGroups: ExtendedMap): boolean {
		if (formGroups.find((f:any) => (f.controls[this.ChangeSet_Status]['value'] == StatusAction.UPDATE
		  || f.controls[this.ChangeSet_Status]['value'] == StatusAction.ADD
		  || f.controls[this.ChangeSet_Status]['value'] == StatusAction.Delete
		  || f.dirty))) {
		  return true;
		}
		return false;
	  }

	  IsDirtyAndCheckValid(formGroups: ExtendedMap): boolean {
		if (formGroups.find((f:any) => ((f.controls[this.ChangeSet_Status]['value'] == StatusAction.UPDATE
		  || f.controls[this.ChangeSet_Status]['value'] == StatusAction.ADD
		  || f.controls[this.ChangeSet_Status].getRawValue() == StatusAction.Delete
		  || f.dirty) && f.status !== 'INVALID'))) {
		  return true;
		}
		return false;
	  }




	  EditSaveSubscription!: Subscription;

	  DoUpdate() {
		const formUpdate = this.formGroups.filter((f:any)=>f.controls[this.ChangeSet_Status].value == StatusAction.UPDATE)[0];
		if (formUpdate?.status === 'VALID' || formUpdate?.status === 'DISABLED') {
		  this._ConvertBoolean2Number(formUpdate);
		  const value = this.PrepareBodyReq({ ...formUpdate?.getRawValue() })
		  delete value?.[this.ChangeSet_Status];
		  delete value?.[this.RowIdentifier];
		  if (false)// till we fully support patch
		  {
			const updatedvalue = this.PrepareBodyReq(this.GetUpdatedProperties(formUpdate));
			delete updatedvalue?.[this.ChangeSet_Status];
			delete updatedvalue?.[this.RowIdentifier];
			const patchJsonDoc = [];
			for (const property in updatedvalue) {
			  let newOp = new JSONPatchReq();
			  newOp.op = 'add';
			  newOp.path = '/' + property;
			  newOp.value = updatedvalue[property];
			  patchJsonDoc.push(newOp)
			}
		  }
		  let save$;
		  if (this.DataService.APIURL == 'HH_AR_PAYMENTTERMS') {
			const updatedvalue = this.PrepareBodyReq(this.GetUpdatedProperties(formUpdate));
			delete updatedvalue?.[this.ChangeSet_Status];
			delete updatedvalue?.[this.RowIdentifier];
			save$ = this.DataService.patch(updatedvalue, this.HandleParamsApiRequest(value))

		  }
		  else {
			save$ = this.DataService.edit(value, this.HandleParamsApiRequest(value))
		  }
		  if (this.EditSaveSubscription)
			this.EditSaveSubscription.unsubscribe();
		  this.EditSaveSubscription = save$
			.pipe(switchMap((res: any) => {
			  return (this.DataService.get(this.HandleFilterApiRequest(this.CurrentSelectRow.getRawValue())))
			}))
			.subscribe((data: any) => {
			  const response = data?.value[0];
			  this.alertShow(this.translateService.instant("SavedSuccessfully"), 2);
			  this.Columns.filter((res) => res.DataType === DataType.Date).map((res) => {
				if (response[res.Name]) response[res.Name] = new Date(response[res.Name]);
			  })

			  this.AfterSave.emit();
			  this.saveAll();

			});
		};
	  }
	  public async SaveWithoutConfirmation() {
		await this.ValidateDirtyBeforeSave(this.formGroups);
		await this.BeforeActionSave();


		if (!this.IsDirty(this.formGroups)) {
		  this.saveAll();
		}
		else if (this.formGroups.find((f:any)=>f.controls[this.ChangeSet_Status].value == StatusAction.ADD)) {
		  // Save Create
		  this.DoAdd();
		} else {
		  // Save Update
		  this.DoUpdate();
		};
	  }


	  public async Save() {
		if(this.CloseAll()==true){
		  await this.ValidateDirtyBeforeSave(this.formGroups);
		  if (this.StopSaveSubscription)
			this.StopSaveSubscription.unsubscribe()
		  this.StopSaveSubscription = this.AllowSave.subscribe((res: any) => {
			if (res) {
			  this.errorDetailsService.ErrorMessagesQueue = [];
			  let AllInvalid = this.changeSet.changesetArr.filter((x) => x.Grid.formGroups.find((y) => y.status == 'INVALID'
				&& (y.dirty == true || y.controls[this.ChangeSet_Status].value == StatusAction.ADD
				  || y.controls[this.ChangeSet_Status].value == StatusAction.UPDATE)))

			  if (AllInvalid.length > 0) {
				AllInvalid.forEach(change => {
				  let currentFG =change.Grid.formGroups.find((y) => y.status == 'INVALID'
					&& (y.dirty == true || y.controls[this.ChangeSet_Status].value == StatusAction.ADD
					  || y.controls[this.ChangeSet_Status].value == StatusAction.UPDATE))

				  change.Grid.DataService.Columns.forEach((res: any) => {
					if (currentFG?.controls[res.Name]?.status == "INVALID") {
					  this.errorDetailsService.PushErrorMessages({
						Title: this.translateService.instant(res.Name) + " " + this.translateService.instant('IsInvalid'),
						Details: this.translateService.instant(res.Name) + " " + this.translateService.instant('IsInvalid'),
						Id: 0,
						Type: 0
					  });
					  ////
					}
				  });

				})
				return;

			  }
			  if (!this.IsDirty(this.formGroups)) {
				this.saveAll();
			  }
			  else if (this.formGroups.find((f:any)=>f.controls[this.ChangeSet_Status].value == StatusAction.ADD)) {
				// Save Create
				this.DoAdd();
			  } else {
				// Save Update
				this.DoUpdate();
			  };
			}
		  });
		  let ret = await this.BeforeActionSave();
		  if (ret === BeforeAction.NoSaveImp) {
			this.AllowSave.next(true);
		  }
		}
	  }
	  async saveAll() {
		var SavedSuccessfullyMsg = this.translateService.instant('SavedsuccessufellyKey');
		for (var index = 0; index < this.changeSet.changesetArr.length; index++) {
		  // if (index == 0 && this.changeSet.changesetArr[index].Grid.constructor.name == 'BIGridComponent') {
		  //   continue;
		  // }
		  if (this.IsDirtyAndCheckValid(this.changeSet.changesetArr[index].Grid.formGroups as ExtendedMap)) {
			let myfg = this.changeSet.changesetArr[index].Grid.formGroups
			await this.ValidateDirtyBeforeSave(myfg as ExtendedMap);

			(function (_this, i, _SavedSuccessfullyMsg) {
			  if (!(_this.changeSet.changesetArr[i].Grid.DataService.excludeDataFromReq as Array<string>).find((ex) => ex == _this.RowIdentifier))
				_this.changeSet.changesetArr[i].Grid.DataService.excludeDataFromReq.push(_this.RowIdentifier);
			  if (!(_this.changeSet.changesetArr[i].Grid.DataService.excludeDataFromReq as Array<string>).find((ex) => ex == _this.ChangeSet_Status))
				_this.changeSet.changesetArr[i].Grid.DataService.excludeDataFromReq.push(_this.ChangeSet_Status);
			  var addedArray = (_this.changeSet.changesetArr[i].Grid.formGroups as FormGroup[]).filter(c => c.controls[_this.ChangeSet_Status]['value'] == 'Add' && c.status == "VALID");
			  var updatedArray = (_this.changeSet.changesetArr[i].Grid.formGroups as FormGroup[]).filter(u => u.controls[_this.ChangeSet_Status]['value'] == 'Update');
			  var deletedArray = (_this.changeSet.changesetArr[i].Grid.formGroups as FormGroup[]).filter(d => d.controls[_this.ChangeSet_Status]['value'] == 'Delete')
			  if ((addedArray.length + updatedArray.length + deletedArray.length) > 1000) {
				_this.alertShow(_this.translateService.instant("CantSaveMoreThan100AtOnce"), 0);
			  }
			  else if (addedArray.length > 0 || updatedArray.length > 0 || deletedArray.length > 0) {
				_this.changeSet.changesetArr[i].Grid.closeRow();
				_this.changeSet.changesetArr[i].Grid.DataService.batch(
				  addedArray
				  , updatedArray,
				  deletedArray
				)
				  .subscribe((response: any) => {
					const statusSuccess = response?.responses.filter((res: any) => res['status'] >= 200 && res['status'] < 300)
					const statusFalid = response?.responses.filter((res: any) => res['status'] > 300);
					if (statusSuccess?.length && !statusFalid?.length) {
					  _this.alertShow(_SavedSuccessfullyMsg, 2)
					  _this.AfterActionSave();
					}

					if (statusFalid.length) {
					  statusSuccess.forEach((element: any) => {
						(_this.changeSet.changesetArr[i].Grid).formGroups.filter(formGroup => {
						  if (formGroup.controls[_this.RowIdentifier].value === element.id) {
							formGroup.get(_this.ChangeSet_Status)?.patchValue(StatusAction.NOP);
						  }
						});
					  });

					  statusFalid.forEach((element: any) => {
						_this.errorDetailsService.PushErrorMessages({
						  Title: element.body.error.message.value,
						  Details: element.body.innerError.trace,
						  Id: 0,
						  Type: 0
						});
						// let gridData: any = _this.changeSet.changesetArr[i].Grid
						// let AddedFormGroup = (_this.changeSet.changesetArr[i].Grid).formGroups
						//   .filter((from) => { return from.controls[_this.RowIdentifier].value === gridData.RowID })[0]?.getRawValue();


						// if (AddedFormGroup && !gridData?.data?.data.
						//   find((res: any) => res[_this.RowIdentifier] == gridData.RowID))
						//   (gridData).data?.data.unshift(AddedFormGroup);
					  });
					}
					if (!statusFalid?.length) {
					  _this.changeSet.changesetArr[i].Grid.read();
					}
				  });
			  }
			  else {
				_this.alertShow(_this.translateService.instant("noValidDataToSave"), 0);
			  }
			})(this, index, SavedSuccessfullyMsg);
		  }
		}
	  }

	   BeforeActionSave() {
		return BeforeAction.NoSaveImp;
	  }

	  _ConvertBoolean2Number(formGroup:FormGroup) {
		var boolean = this.Columns.filter(x => x.IsNumber2Boolean == true).map(x => x.Name);
		if (formGroup) {
		  boolean.forEach((column) => {
			formGroup.controls[column].patchValue(
			  +formGroup?.get(column)?.getRawValue()
			)
		  });
		}
	  }
	  PrepareBodyReq(data: any) {
		if (this.DataService.excludeDataFromReq.length) {
		  this.DataService.excludeDataFromReq.forEach((res: any) => delete data[res])
		};
		return data;
	  }
	  public GetUpdatedProperties(myForm: FormGroup<any> | undefined): any {
		const updatedControls = [];
		let updatedProp: any = {}
		if (!myForm)
		  return null
		for (const controlName in myForm.controls) {
		  if (myForm.get(controlName) && !myForm.get(controlName)?.pristine) {
			updatedControls.push(controlName);
			updatedProp[controlName] = myForm.get(controlName)?.getRawValue();
		  }
		}
		return updatedProp;
	  }
	  HandleParamsApiRequest(Value: any): string {
		// if have more than one key
		if (this.DataService.Key && this.DataService.Key2) {
		  return (
			`${this.DataService.Key}=${this.HandleFormateTypeKeysReq(this.DataService.Key, Value)}`
			+ (this.DataService.Key2 ? `,${this.DataService.Key2}=${this.HandleFormateTypeKeysReq(this.DataService.Key2, Value)}` : '')
			+ (this.DataService.Key3 ? `,${this.DataService.Key3}=${this.HandleFormateTypeKeysReq(this.DataService.Key3, Value)}` : '')
			+ (this.DataService.Key4 ? `,${this.DataService.Key4}=${this.HandleFormateTypeKeysReq(this.DataService.Key4, Value)}` : '')
			+ (this.DataService.Key5 ? `,${this.DataService.Key5}=${this.HandleFormateTypeKeysReq(this.DataService.Key5, Value)}` : '')
			+ (this.DataService.Key6 ? `,${this.DataService.Key6}=${this.HandleFormateTypeKeysReq(this.DataService.Key6, Value)}` : ''))
		}
		return Value[this.DataService.Key]
	  }
	  HandleFormateTypeKeysReq(Key: string, Value: any) {
		if (this.getTypeFilter(Key) === DataType.Date) {
		  return new Date(Value[Key]).getFullYear() + "-" + (new Date(Value[Key]).getMonth() + 1) + "-" + new Date(Value[Key]).getDate();
		} else if (this.getTypeFilter(Key) === DataType.Text) {
		  return "'" + Value[Key] + "'";
		}
		return Value[Key];
	  }
	  getTypeFilter(Key: string) {
		return this.DataService.Columns.find((f: { Name: string; DataType: DataType; }) => f.Name == Key)?.DataType;
	  }
	  HandleFilterApiRequest(response: any) {
		return (this.DataService.APIURL
		  + (!this.DataService.APIURL.includes('?') ? '?' : '')
		  + (this.DataService.APIURL.includes('filter') ? ' and ' : '&$filter=') + `${this.DataService.Key} eq ${this.HandleFormateTypeKeysReq(this.DataService.Key, response)}`
		  + (this.DataService.Key2 ? ` and ${this.DataService.Key2} eq ${this.HandleFormateTypeKeysReq(this.DataService.Key2, response)}` : '')
		  + (this.DataService.Key3 ? ` and ${this.DataService.Key3} eq ${this.HandleFormateTypeKeysReq(this.DataService.Key3, response)}` : '')
		  + (this.DataService.Key4 ? ` and ${this.DataService.Key4} eq ${this.HandleFormateTypeKeysReq(this.DataService.Key4, response)}` : '')
		  + (this.DataService.Key5 ? ` and ${this.DataService.Key5} eq ${this.HandleFormateTypeKeysReq(this.DataService.Key5, response)}` : '')
		  + (this.DataService.Key6 ? ` and ${this.DataService.Key6} eq ${this.HandleFormateTypeKeysReq(this.DataService.Key6, response)}` : ''))
	  }
	  alertShow(content: string, type: number) {
		this.loggerService.Content = this.translateService.instant(content);
		this.loggerService.Type = type;
		this.loggerService.Show();
	  }
	  closeRow(rowIndex?: number) {
		this.OnCloseRow.emit(null);
	   // this.Mygrid.closeRow(rowIndex);
	  }
	  AfterActionSave(): void {
	  }
	  DoAdd() {
		let RowID=this.formGroups.find((f:any)=>f.controls[this.ChangeSet_Status].value == StatusAction.ADD)?.controls[this.RowIdentifier].value;
		if ( this.formGroups.get(RowID)?.status === 'VALID' || this.formGroups.get(RowID)?.status === 'DISABLED')// why don't use currentselectedrow
		{
		  this.ConvertBoolean2Number();
		  let value = this.PrepareBodyReq({ ...this.formGroups.get(RowID).getRawValue() });

		  delete value[this.ChangeSet_Status];
		  delete value[this.RowIdentifier];

	let Add$;
	Add$=this.DataService.add(value);
	this.AddSubscription = Add$.pipe(switchMap((res: any) => {
			return (this.DataService.get(this.HandleFilterApiRequest(res)))
		  })).subscribe((data: any) => {
			const response = data?.value[0] ? data?.value[0] : data;
			this.alertShow(this.translateService.instant("SavedSuccessfully"), 2);
			this.Columns.filter((res) => res.DataType === DataType.Date).map((res) => {
			  if (response[res.Name]) response[res.Name] = new Date(response[res.Name]);
			})
			this.formGroups.get(RowID)?.patchValue({ ...response, [this.ChangeSet_Status]: null, [this.RowIdentifier]: RowID });
			if(this.formGroups.get(RowID)?.controls){
				Object.keys(this.formGroups.get(RowID)?.controls).forEach((name: any) => {
					if (name.includes(".")) this.formGroups.get(RowID)?.controls[name].patchValue(this.getValuePipe.get(response, name));
				  })
			}
			this.closeRow();
			//this.OverviewDataBindingSubscribtion(RowID);
			if (this.formGroups.get(RowID)) {
			  this.formGroups.get(RowID).markAsPristine();
			}
			this.ResetRowUpdateStatus();
			this.saveAll();
			this.AfterAdd.emit(response);
		  })
		};
	  }
	  ResetRowUpdateStatus() {
		this.statusAction = StatusAction.NOP;
	  }
	  BeforeActionDelete() {
		return BeforeAction.NoDeleteImp;
	  }
	  Cancel(){this.read();}
	  ConvertBoolean2Number(){}
	  ngOnDestroy(): void {
		// this.GridDataSubscription?.unsubscribe();
		// this.RowSubscription?.unsubscribe();
		// this.StopDeleteSubscription?.unsubscribe();
		// this.StopAddSubscription?.unsubscribe();
		// this.StopSaveSubscription?.unsubscribe();
		// this.DeleteSubscription?.unsubscribe();
		// this.AddSubscription?.unsubscribe();
		this.EditSaveSubscription?.unsubscribe();
		//this.setPreventCloseRowSubscription?.unsubscribe();
		// if (this.changeSet?.changesetArr?.findIndex((res: any) => res.Grid?.GridID == this.GridID) >= 0)
		//   this.changeSet.changesetArr.splice(this.changeSet.changesetArr.findIndex((res: any) => res.Grid?.GridID == this.GridID), 1)
	  }
	  CardChange(rowid:any,EnterEditMode:boolean=false)
	  {
		//if(this.CloseAll()==true){
			if(!this.CheckPendingChange() || this.IsChild==true){
				if(rowid!=this.CurrentSelectRow?.controls[this.RowIdentifier].value){
					this.CurrentSelectRow=this.formGroups.get(rowid);
					this.OnCardChange.emit();
				}
				//if(EnterEditMode) this.IneditMode.set(rowid,true);

			}else{
			  if(rowid!=this.CurrentSelectRow?.controls[this.RowIdentifier].value)
				 this.alertShow(this.translateService.instant('Savependingchanges'), 1);
			}
		//}
	  }
	  CloseAll(){
		for (let [key, value] of this.IneditMode) {
		  if(value==true){
			if(this.CloseCard(key)==false){
			  return false;
			}
			else{
			  this.IneditMode.set(key,false);
			}
		  }
	  }
	  return true;
	  }
	  CloseCard(rowid:any){
		const controls = this.formGroups.get(rowid).controls;
	if (this.formGroups.get(rowid).status === 'INVALID') {
	  return false;
	}
	if(this.formGroups.get(rowid)?.dirty && this.formGroups.get(rowid).controls[this.ChangeSet_Status]['value'] != StatusAction.ADD){
	  this.formGroups.get(rowid).patchValue({ [this.ChangeSet_Status]: StatusAction.UPDATE });
	}
	this.CellClose.emit();
	this.IneditMode.set(this.formGroups.get(rowid).controls[this.RowIdentifier]['value'],false);
	return true;
	  }

	  EnterEditMode(dataItem:any){
		let rowid=dataItem[this.RowIdentifier];
		if(this.CloseAll()==true){
			if(!this.CheckPendingChange() || this.IsChild==true || this.IsDirty(this.formGroups.get(rowid))){
				if(rowid!=this.CurrentSelectRow?.controls[this.RowIdentifier].value){
					this.CurrentSelectRow=this.formGroups.get(rowid);
					this.OnCardChange.emit();
				}
				this.IneditMode.set(rowid,true);
			}else{
				this.alertShow(this.translateService.instant('Savependingchanges'), 1);
			}
		}
		//this.CardChange(dataItem[this.RowIdentifier],true);
	  }
	  ExitEditMode(dataItem:any){

	  }

	  public EnableDisable_columns(colmnNames: string[], IsEditable: boolean): void {
		if (IsEditable) {
		  colmnNames.forEach(columnName => {
			this.CurrentSelectRow?.controls[columnName]?.enable({ emitEvent: false });
		  });
		} else {
		  colmnNames.forEach(columnName => {
			this.CurrentSelectRow?.controls[columnName]?.disable({ emitEvent: false });
		  });
		}
		this.Columns = this.Columns.filter(res => {
		  if (colmnNames.includes(res.Name)) {
			res.IsEditable = IsEditable;
		  }
		  return res;
		})
	  }
	  public ClearGrid() {
		this.CurrentSelectRow = this.formBuilder.group(this.form);
		this.formGroups = new ExtendedMap();
		this.IneditMode=new Map<string,boolean>();
	  }
}
